import React from 'react';
import Work from '../../../SVG/Caf/WorkIcon';
import Weekends from '../../../SVG/Caf/WeekendIcon';
import Events from '../../../SVG/Caf/EventsIcon';
import Dresses from '../../../SVG/Caf/DressesIcon';
import Tops from '../../../SVG/Caf/TopsIcon';
import Bottoms from '../../../SVG/Caf/BottomsIcon';
import { ICON_MAPPINGS } from '../../../../config/caf';

type ImageProps = {
  imageLink: string;
};

const RenderImageOptions = (props: ImageProps): JSX.Element => {
  const { imageLink } = props;

  switch (imageLink) {
    case ICON_MAPPINGS.WORK:
      return <Work fillColor='black' />;
    case ICON_MAPPINGS.WEEKEND:
      return <Weekends fillColor='black' />;
    case ICON_MAPPINGS.EVENT:
      return <Events fillColor='black' />;
    case ICON_MAPPINGS.DRESS:
      return <Dresses fillColor='black' />;
    case ICON_MAPPINGS.TOP:
      return <Tops fillColor='black' />;
    case ICON_MAPPINGS.BOTTOM:
      return <Bottoms fillColor='black' />;
    default:
      return <></>;
  }
};

export default RenderImageOptions;
